export const BUILDER_CONTENT_MIN_WIDTH = 200;

export const API_FORM_SERVICE_NAME = 'form';

export const API_SHOW_METHOD_NAME = 'show';
export const API_STATIC_ENDPOINTS_SCHEMA = {
  [API_SHOW_METHOD_NAME]: true
};
